import PropTypes from 'prop-types';
import React     from 'react';

import reactStringReplace from 'react-string-replace';

import Link       from '@mui/material/Link';
import Typography from '@mui/material/Typography';

function Linkify({ children }) {
  // NOTE: having a problem using the regex from helpers/url `isValidURL()` so this one was copied from Profile/Details.jsx in legacy
  const regex = /((?:(?:https?|ftp):\/\/)(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))?)/ig;

  return reactStringReplace(children, regex, (match, i) => (
    <Link key={match + i} href={match} underline="none" target="_blank">
      <Typography variant="p">{match}</Typography>
    </Link>
  ));
}

Linkify.defaultProps = {
  children: null,
};

Linkify.propTypes = {
  children: PropTypes.string,
};

export default Linkify;
